import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';

@Component({
  selector: 'app-supplier-invoice-detail',
  templateUrl: './supplier-invoice-detail.component.html',
  styleUrls: ['./supplier-invoice-detail.component.css']
})
export class SupplierInvoiceDetailComponent implements OnInit {

  supplier_info = [];
  page_title: string;
  supplier_name: string;
  supplier_no: string;
  mobile: string;

  private dp = [];

  displayedColumns = ['supplier_invoice_no', 'invoice_date', 'discount', 'tax', 'amount'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<SupplierInvoiceDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any) { }

  ngOnInit() {

    this.supplier_info = this.dialog_data;

    this.supplier_name = this.supplier_info['supplier_name'];
    this.supplier_no = this.supplier_info['supplier_no'];
    this.mobile = this.supplier_info['mobile'];

    let query;

    if (this.supplier_info['type'] == 'all') {
      this.page_title = 'فواتير المشتريات';
      query = "SELECT * FROM `supplier_invoice` WHERE `status`='1' AND `supplier_no` ='" + this.supplier_no + "'";
    }
    else {
      this.page_title = 'تفاصيل المشتريات';
      query = "SELECT * FROM `supplier_invoice` WHERE `status`='1' AND `supplier_no` ='" + this.supplier_no +
        "' AND `is_paid` = '0'";
    }
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });

  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }

}
